// extracted by mini-css-extract-plugin
export default {"headbar":"Headbar_headbar__F7IAG","shipBtn":"Headbar_shipBtn__1+ee1","address":"Headbar_address__9WrZT"};